import type { RequestResponse } from '@/types/publicType'
import type {
  chargeInterface,
  chicChargePopupInterface
} from '@/types/apiType/rechargeType'

// 获取充值订单列表
export function getChargeList(params: {
  channelType: number
  countryCode: string
}): Promise<RequestResponse<chargeInterface[]>> {
  return getFetchData({
    url: '/pay/payermax/charge/list',
    method: 'GET',
    params
  })
}

// 创建订单
export function getOrder(data: {
  chargeProdId: string
  countryCode: string
  paymentType: string
  app: string
}) {
  return getFetchData({
    url: '/pay/payermax/generate/order/web',
    method: 'POST',
    data
  })
}

// 获取结果
export function getResult(params: { chargeRecordId: string }) {
  return getFetchData({
    url: '/pay/payermax/results/show',
    method: 'GET',
    params
  })
}

// 创建订单-livpay创建接口
export function getLivpayCreate(data: {
  param: string
  chargeId: string
  app: string
}) {
  return getFetchData({
    url: '/charge/h5CreateOrder',
    method: 'POST',
    data
  })
}

// 判断是否充值过
export function apiGetIsRecharged(): Promise<RequestResponse<boolean>> {
  return getFetchData({
    url: '/h5/c/isRecharged',
    method: 'GET'
  })
}

/** App获取首充倒计时 */
export function apiChicChargePopup(): Promise<
  RequestResponse<chicChargePopupInterface>
> {
  return getFetchData({
    url: '/chic/h5/charge-popup',
    method: 'GET'
  })
}
